/*================ START FOXBOX: TABLET COVER BROWSER ================*/
(() => {
  'use strict';
  const root = document.querySelector('[data-cover-browser]');
  if (!root) return;
  const controls = root.querySelector('[data-controls]');
  if (!controls) return;
  const grid = root.querySelector('[data-products]');
  const status = root.querySelector('[data-status]');
  const error = root.querySelector('[data-error]');
  const search = controls.elements.model;
  const sort = controls.elements.sort_by;
  const manufacturers = [...controls.querySelectorAll('[name="manufacturer"]')];
  const details = controls.querySelector('details');
  const makerLabels = controls.querySelector('[data-maker-labels]');
  const makerLabel = makerLabels.textContent.trim();
  const clearSearch = controls.querySelector('[data-clear-search]');
  const clearMakers = controls.querySelector('[data-clear-makers]');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const animations = new Set();
  const normalize = value => value.toLocaleLowerCase().replace(/[^\p{L}\p{N}]/gu, '');
  const collator = new Intl.Collator(document.documentElement.lang || 'en', { numeric: true, sensitivity: 'base' });
  let products = [];
  let ready = false;
  let searchTimer;

  function updateMakerLabels() {
    const selected = manufacturers.filter(input => input.checked).map(input => input.value);
    controls.querySelector('.fb-covers__maker').classList.toggle('fb-covers__maker--selected', selected.length > 0);
    clearMakers.hidden = !selected.length;
    const label = selected.length ? `${makerLabel}: ${selected.join(', ')}` : makerLabel;
    details.querySelector('summary').setAttribute('aria-label', label);
    details.querySelector('summary').title = label;
    makerLabels.replaceChildren();
    if (!selected.length) { makerLabels.textContent = makerLabel; return; }
    const chips = selected.map(name => {
      const chip = document.createElement('span');
      chip.className = 'fb-covers__maker-chip';
      chip.textContent = name;
      makerLabels.append(chip);
      return chip;
    });
    const more = document.createElement('span');
    more.className = 'fb-covers__maker-more';
    let shown = chips.length;
    const width = makerLabels.clientWidth;
    if (!width) return;
    while (shown > 1 && makerLabels.scrollWidth > width) {
      chips[--shown].remove();
      more.textContent = `+${selected.length - shown}`;
      makerLabels.append(more);
    }
    // The first maker remains identifiable even on narrow phones; the summary's
    // accessible name and tooltip always contain every selected maker in full.
    if (shown === 1) chips[0].style.flexShrink = '1';
  }

  function animate(node, frames, options, finished) {
    const animation = node.animate(frames, options);
    animations.add(animation);
    animation.finished.catch(() => {}).finally(() => { animations.delete(animation); finished?.(); });
  }

  function showProducts(matches, withMotion) {
    const current = [...grid.querySelectorAll(':scope > [data-cover]')];
    const before = new Map(current.map(node => [node, node.getBoundingClientRect()]));
    const opacity = new Map(current.map(node => [node, Number(getComputedStyle(node).opacity)]));
    animations.forEach(animation => animation.cancel());
    grid.querySelectorAll('.fb-cover--leaving').forEach(node => node.remove());
    const incoming = matches.map(product => product.node);
    const next = new Set(incoming);
    const leaving = withMotion && !reducedMotion.matches ? current.filter(node => !next.has(node)) : [];
    // Keep real cards so loaded images survive every filter.
    grid.replaceChildren(...incoming);
    if (!withMotion || reducedMotion.matches) return;
    const origin = grid.getBoundingClientRect();
    const visible = rect => rect.bottom > 0 && rect.top < innerHeight;
    leaving.forEach(node => {
      const rect = before.get(node);
      if (!visible(rect)) return;
      const ghost = node.cloneNode(true);
      ghost.removeAttribute('data-cover');
      ghost.classList.add('fb-cover--leaving');
      ghost.setAttribute('aria-hidden', 'true');
      ghost.inert = true;
      Object.assign(ghost.style, { left: `${rect.left - origin.left}px`, top: `${rect.top - origin.top}px`, width: `${rect.width}px`, height: `${rect.height}px` });
      grid.append(ghost);
      animate(ghost, [{ opacity: opacity.get(node), transform: 'translateY(0) scale(1)' }, { opacity: 0, transform: 'translateY(-10px) scale(.97)' }],
        { duration: 160, easing: 'ease-out', fill: 'forwards' }, () => ghost.remove());
    });
    incoming.forEach((node, index) => {
      const rect = node.getBoundingClientRect();
      const old = before.get(node);
      if (!visible(rect) && (!old || !visible(old))) return;
      const dx = old ? old.left - rect.left : 0;
      const dy = old ? old.top - rect.top : 14;
      if (old && Math.abs(dx) < 1 && Math.abs(dy) < 1 && opacity.get(node) >= .99) return;
      animate(node, [{ opacity: old ? opacity.get(node) : 0, transform: `translate(${dx}px, ${dy}px) scale(${old ? 1 : .98})` }, { opacity: 1, transform: 'translate(0, 0) scale(1)' }],
        { duration: 320, delay: old ? 0 : Math.min(index, 5) * 18, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards' });
    });
  }

  function legacyManufacturers(params) {
    // Globo encodes tag filters as gf_<store-specific filter ID>. Recognize known
    // manufacturer values rather than baking a production filter ID into dev code.
    return [...params].filter(([key]) => /^gf_\d+$/.test(key))
      .flatMap(([, value]) => value.split(','))
      .filter(value => manufacturers.some(input => input.value === value));
  }

  function restoreState() {
    const params = new URL(location.href).searchParams;
    search.value = params.get('model') || params.get('q') || '';
    sort.value = params.get('sort_by') || 'best-selling';
    if (!sort.value) sort.value = 'best-selling';
    const selected = [...params.getAll('manufacturer'), ...legacyManufacturers(params)];
    manufacturers.forEach(input => { input.checked = selected.includes(input.value); });
  }

  function writeState(replace = false) {
    const url = new URL(location.href);
    const oldFilters = [...url.searchParams].filter(([key, value]) => /^gf_\d+$/.test(key) &&
      value.split(',').some(brand => manufacturers.some(input => input.value === brand))).map(([key]) => key);
    ['model', 'q', 'manufacturer', 'sort_by', 'page', ...oldFilters].forEach(key => url.searchParams.delete(key));
    if (search.value.trim()) url.searchParams.set('model', search.value.trim());
    manufacturers.filter(input => input.checked).forEach(input => url.searchParams.append('manufacturer', input.value));
    if (sort.value !== 'best-selling') url.searchParams.set('sort_by', sort.value);
    // Preserve preview_theme_id, locale, and any unrelated theme-preview parameters.
    if (url.href !== location.href) history[replace ? 'replaceState' : 'pushState'](null, '', url);
  }

  function filter(replace = false, updateURL = true, withMotion = true) {
    if (!ready) return;
    const words = search.value.trim().split(/\s+/).map(normalize).filter(Boolean);
    const matchesSearch = product => words.every(word => product.search.includes(word));
    const selected = manufacturers.filter(input => input.checked).map(input => input.value);
    const matches = products.filter(product => matchesSearch(product) && (!selected.length || selected.some(brand => product.tags.includes(brand))));
    const comparators = {
      'best-selling': (a, b) => a.rank - b.rank,
      'title-ascending': (a, b) => collator.compare(a.title, b.title)
    };
    matches.sort((a, b) => comparators[sort.value](a, b) || a.rank - b.rank);
    showProducts(matches, withMotion);
    root.querySelector('[data-empty]').hidden = matches.length > 0;
    status.textContent = `${matches.length} of ${products.length} products`;
    manufacturers.forEach(input => {
      const count = products.filter(product => matchesSearch(product) && product.tags.includes(input.value)).length;
      input.parentElement.querySelector('[data-count]').textContent = `(${count})`;
    });
    updateMakerLabels();
    clearSearch.hidden = !search.value;
    if (updateURL) writeState(replace);
  }

  function index(nodes) {
    return nodes.map((node, rank) => {
      const tags = JSON.parse(node.dataset.tags);
      const price = Number(node.dataset.price);
      const compare = Number(node.dataset.compare);
      return {
        node, rank, tags, price, title: node.dataset.title,
        search: normalize(`${node.dataset.title} ${tags.join(' ')}`),
        available: node.dataset.available === 'true',
        created: Number(node.dataset.created),
        discount: compare > price ? (compare - price) / compare : 0
      };
    });
  }

  function dataURL(page = 1) {
    const url = new URL(root.dataset.collectionUrl, location.origin);
    const current = new URL(location.href);
    ['preview_theme_id', '_fd', 'pb', 'preview_key'].forEach(key => {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    });
    url.searchParams.set('view', 'foxbox-data');
    url.searchParams.set('sort_by', 'best-selling');
    url.searchParams.set('page', page);
    return url;
  }

  async function load() {
    ready = false;
    error.hidden = true;
    status.textContent = 'Preparing collection filters…';
    root.querySelector('[data-retry]').disabled = true;
    try {
      // Reuse Liquid output when it is the unfiltered first page in best-selling order.
      // Otherwise request that order from Shopify: popularity must never be guessed locally.
      const reuse = root.dataset.sort === 'best-selling' && root.dataset.page === '1' && root.dataset.tagged === 'false';
      let nodes = reuse ? [...grid.querySelectorAll('[data-cover]')] : [];
      let expected = Number(root.dataset.total);
      let next = reuse ? root.dataset.next : dataURL().href;
      let page = reuse ? 2 : 1;
      const ids = new Set(nodes.map(node => node.dataset.id));
      while (next) {
        const response = await fetch(dataURL(page), { signal: AbortSignal.timeout(15000), credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const chunk = doc.querySelector('[data-cover-page]');
        if (!chunk) throw new Error('Collection data template unavailable');
        const chunkNodes = [...chunk.querySelectorAll('[data-cover]')];
        expected = Number(chunk.dataset.total);
        chunkNodes.forEach(node => {
          if (ids.has(node.dataset.id)) throw new Error('Collection pagination changed');
          ids.add(node.dataset.id);
          nodes.push(document.importNode(node, true));
        });
        next = chunk.dataset.next;
        if (next && !chunkNodes.length) throw new Error('Empty collection page');
        page += 1;
        status.textContent = `Preparing filters: ${nodes.length} of ${expected} products…`;
      }
      // Never label partial data as the complete set, including Shopify's pagination ceiling.
      if (nodes.length !== expected) throw new Error('Collection changed or could not be loaded completely');
      products = index(nodes);
      ready = true;
      restoreState();
      controls.hidden = false;
      root.querySelector('[data-fallback-pagination]')?.setAttribute('hidden', '');
      filter(false, false, false);
    } catch (err) {
      error.hidden = false;
      status.textContent = 'Browse products below; collection filters are unavailable.';
      console.warn('Foxbox collection filters:', err.message);
    } finally {
      root.querySelector('[data-retry]').disabled = false;
    }
  }

  controls.addEventListener('submit', event => { event.preventDefault(); clearTimeout(searchTimer); filter(); });
  search.addEventListener('input', () => {
    clearTimeout(searchTimer);
    // Search keystrokes replace the current entry rather than filling browser history.
    searchTimer = setTimeout(() => filter(true), 120);
  });
  controls.addEventListener('change', event => { if (event.target !== search) filter(); });
  clearSearch.addEventListener('click', () => {
    clearTimeout(searchTimer);
    search.value = '';
    filter();
    search.focus();
  });
  clearMakers.addEventListener('click', () => {
    clearTimeout(searchTimer);
    manufacturers.forEach(input => { input.checked = false; });
    filter();
    details.querySelector('summary').focus();
  });
  details.addEventListener('keydown', event => {
    if (event.key === 'Escape') { details.open = false; details.querySelector('summary').focus(); }
  });
  document.addEventListener('click', event => { if (!details.parentElement.contains(event.target)) details.open = false; });
  new ResizeObserver(updateMakerLabels).observe(makerLabels);
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) {
      animations.forEach(animation => animation.cancel());
      grid.querySelectorAll('.fb-cover--leaving').forEach(node => node.remove());
    }
  });
  window.addEventListener('popstate', () => { clearTimeout(searchTimer); restoreState(); filter(false, false); });
  root.querySelector('[data-retry]').addEventListener('click', load);
  load();
})();
/*================ END FOXBOX: TABLET COVER BROWSER ================*/
